import { ApiEpBilling } from "@smp/api";
import { useQuery } from "react-query";

const KEY = "ep.billing.payment_provider";

export const useEpBillingPaymentProvider = () => {
  const { data: paymentProviderList, isLoading: isPaymentProviderListLoading } =
    useQuery([KEY], () => ApiEpBilling.PaymentProvider.list());
  return { isPaymentProviderListLoading, paymentProviderList };
};
